import { Routes } from '@angular/router';
import { PrivacyPolicyComponent } from './privacy-policy.component';

export const PrivacyPolicyRoutes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        component: PrivacyPolicyComponent,
      },
    ],
  },
];
